import { onInboxPivotSelected } from '../actions/onInboxPivotSelected';
import { onPivotEnableDisableDialogSave } from 'owa-mail-inbox-plus-store';
import { mutator } from 'satcheljs';
import onFolderChangeDigestResponse from '../actions/onFolderChangeDigestResponse';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import inboxPlusStore from 'owa-mail-inbox-plus-store/lib/store/Store';

mutator(onInboxPivotSelected, actionMessage => {
    setUnseenDataForPivot(actionMessage.currentPivot, 0, []);
    setUnseenDataForPivot(actionMessage.pivotToSelect, 0, []);
});

mutator(onPivotEnableDisableDialogSave, actionMessage => {
    for (const pivot of actionMessage.pivotsToSet) {
        setUnseenDataForPivot(pivot.InboxClassificationFilter, 0, []);
    }
});

mutator(onFolderChangeDigestResponse, actionMessage => {
    setUnseenDataForPivot(
        actionMessage.pivot,
        actionMessage.unseenCount,
        actionMessage.recentSenders
    );
});

function setUnseenDataForPivot(
    pivotType: InboxClassificationFilter,
    unseenCount: number,
    recentSenders: string[]
) {
    for (const pivotData of inboxPlusStore.inboxPlusPivots) {
        if (pivotData.InboxClassificationFilter == pivotType) {
            pivotData.unseenCount = unseenCount;
            pivotData.recentSenders = recentSenders;
        }
    }
}
